import { get, map } from 'lodash/fp';
import { copyStyles } from '../../../../api/designBuilder';

export default (designId, sourceItem, targetItems) => {
  const targetItemIds = map('itemId', targetItems);
  const sourceItemId = get('itemId', sourceItem);

  return copyStyles(designId, sourceItemId, targetItemIds);
};
